import request from '@/utils/request';

//小程序模板消息详情
export function getWmpTemplateDetail(values) {
  return request('/wechat/queryWmpTempDetail', {
    method: 'POST',
    data: values,
  });
}
//小程序模板详情
export function getWmpTemplateMessageDetail(values) {
  return request('/wechat/queryWmpTempMsgDetail', {
    method: 'POST',
    data: values,
  });
}

//小程序模板消息列表
export function getWmpTemplateMessageList(values) {
  return request('/wechat/queryWmpTempMsgPage', {
    method: 'POST',
    data: values,
  });
}
//查询微信模板消息变量定义列表
export function getTempMsgVariableList() {
  return request('/wechat/queryTempMsgVariableList', {
    method: 'GET',
    // data: values,
  });
}

//小程序新增模板
export function addWmpTemplate(values) {
  return request('/wechat/addWmpTempMsg', {
    method: 'POST',
    data: values,
  });
}

//小程序更新模板
export function updateWmpTemplate(values) {
  return request('/wechat/updateWmpTempMsg', {
    method: 'POST',
    data: values,
  });
}
